import Cookies from "js-cookie";

import {
  AUTHORIZATION_LOGIN_FAILURE,
  AUTHORIZATION_LOGIN_SUCCESS,
  AUTHORIZATION_LOGOUT_SUCCESS,
  CHECK_ACCESS_TOKEN,
  FIRST_LOGIN_FAILURE,
  FIRST_LOGIN_SUCCESS,
  REFRESH_ACCESS_TOKEN,
  REFRESH_REFRESH_TOKEN,
  REFRESH_REFRESH_TOKEN_ERROR,
  SET_LOGIN_STATUS,
} from "../types";

const initialState = {
  authData: {
    isLogin: false,
    refreshToken: "",
    checkAccessToken: null,
    tokenError: "",
    accessToken: "",
    isAuthorized: false,
    errorText: "",
    message: "",
  },
  profileData: {
    profile: "",
    error: null,
  },
};

export const authLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTHORIZATION_LOGIN_SUCCESS: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          isAuthorized: action.data.isAuthorized,
          isLogin: true,
          accessToken: action.data.accessToken,
          refreshToken: action.data.refreshToken,
          errorText: "",
        },
      }))();
    }

    case AUTHORIZATION_LOGIN_FAILURE: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          errorText: action.data,
        },
      }))();
    }

    case SET_LOGIN_STATUS:
      return {
        ...state,
        authData: {
          ...state.authData,
          isLogin: action.payload,
        },
      };

    case REFRESH_ACCESS_TOKEN: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          accessToken: action.data.accessToken,
          isLogin: true,
        },
      }))();
    }
    case REFRESH_REFRESH_TOKEN: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          refreshToken: action.data.refreshToken,
        },
      }))();
    }
    case REFRESH_REFRESH_TOKEN_ERROR: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          tokenError: action.data,
        },
      }))();
    }
    case FIRST_LOGIN_SUCCESS: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          isAuthorized: false,
          isLogin: true,
          errorText: "",
          message: action.data,
        },
      }))();
    }
    case CHECK_ACCESS_TOKEN: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          checkAccessToken: action.data,
        },
      }))();
    }
    case FIRST_LOGIN_FAILURE: {
      return (() => ({
        ...state,
        authData: {
          ...state.authData,
          message: action.data,
        },
      }))();
    }

    case AUTHORIZATION_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};
